import {FacebookSettings} from "./FacebookSettings";
import {SimpleCommand} from "./../../../commanding/SimpleCommand";
import {ExternalInterface} from "@goodgamestudios/createjs-utilities";


export class BasicFacebookConnectCommand extends SimpleCommand {
    public static gameID: number;

    public execute(commandVars: any = null): void {
        ExternalInterface.addCallback(FacebookSettings.FACEBOOK_CALLBACK_NAME, this.bindFunction(this.jsFacebookLoginCallback));
        ExternalInterface.call(FacebookSettings.FACEBOOK_JS_LOGIN_METHOD, BasicFacebookConnectCommand.gameID); // add instance ID as last parameter
    }

    /**
     *
     * Callback function, which can be called from javaScript to send login-data to flash.
     * This method can be override by your project
     *
     * */
    protected jsFacebookLoginCallback(pln: string, sig: string, displayName: string, country: string): void {
        // for override
    }
}

